module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-3-4151e3a908bebec5737bc2fea587a9a9.webp";